import { NewFeatureAlert } from '@/types';

import { RootState } from '../store';
import { initialState } from './user-preferences.slice';
import { NewFeatureAlertState } from './user-preferences.types';

export const selectPersistedPlayerSpeedPreference = (state: RootState) =>
  state.session.data?.userId
    ? state.userPreferences.playbackSpeed
    : initialState.playbackSpeed;

export const selectPersistedPlayerVolumePreference = (state: RootState) =>
  state.userPreferences.playbackVolume;

export const selectIsGetStartedSectionDismissed = (state: RootState) =>
  state.userPreferences.isGetStartedSectionDismissed;

export const selectIsShareWithAFriendDismissed = (state: RootState) =>
  state.userPreferences.isShareWithAFriendDismissed;

export const selectIsTeamUpgradePromptDismissed = (state: RootState) =>
  state.userPreferences.isTeamUpgradePromptDismissed;

export const selectKeepGoingPromoLastShownAt = (state: RootState) =>
  state.userPreferences.keepGoingPromoLastShownAt;

export const selectNewFeatureAlertState = (
  state: RootState,
  alertId: NewFeatureAlert,
): NewFeatureAlertState | undefined => state.userPreferences[alertId];

export const selectDismissedEmailPreferenceWarnings = (state: RootState) =>
  state.userPreferences.dismissedEmailPreferenceWarnings;

export const selectIsExpandedPlayerGlowDismissed = (state: RootState) =>
  state.userPreferences.isExpandedPlayerGlowDismissed;

export const selectIsPdfPageControlsGlowDismissed = (state: RootState) =>
  state.userPreferences.isPdfPageControlsGlowDismissed;

export const selectIsPinnedFieldsOfStudyDismissed = (state: RootState) =>
  state.userPreferences.isPinnedFieldsOfStudyDismissed;

export const selectIsLpsListView = (state: RootState) =>
  state.userPreferences.isLpsListView;

export const selectIsTriennialSummaryExpanded = (state: RootState) =>
  state.userPreferences.isTriennialSummaryExpanded;
